<script>
    // @ts-nocheck
    import Comprobantes from './Tranferencias.svelte'
    import Retenciones from './Retenciones.svelte'
    import { TabSetX as TabSet } from '$lib/components/UI'
</script>

<div class="tab">
    <TabSet.Group>
        <TabSet.Tab label="Transferencias">
            <Comprobantes />
        </TabSet.Tab>
        <TabSet.Tab label="Retenciones">
            <Retenciones />
        </TabSet.Tab>
    </TabSet.Group>
</div>

<style>
    .tab {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 50px 70px;
        gap: 15px;
        position: inherit;
        flex-direction: column;
    }
</style>
